<template>
  <div v-if="order && order.order_invoice" class="order-invoice-tag">
    <el-popover
      ref="popover"
      placement="bottom"
      trigger="hover"
    >
      <div class="invoice-popover">
        <div class="invoice-info-item" v-if="order.order_invoice.invoice_no">发票号码：{{order.order_invoice.invoice_no}}</div>
        <div class="invoice-info-item">申请日期：{{order.order_invoice.invoice_date}}</div>
      </div>
    </el-popover>
    <div class="invoice-tag" v-popover:popover>票</div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    order: Object,
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.order-invoice-tag{
  .invoice-tag{
    margin-right: 16px;
    width: 28px;
    height: 28px;
    background: #FF8033;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #fff;
    font-size: 14px;
    border-radius: 4px;
  }
}
.invoice-popover{
  display: flex;
  align-items: center;
  .invoice-info-item{
    margin-right: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order-list/order-invoice-tag.vue